import LandingLayout from "@/components/layout/LandingPageLayout";
import SectorEcosystemPage from "@/pages/sector-ecosystem/SectorEcosystemPage";

  export function SectorGuestView() {
  return (
    <LandingLayout>
      <SectorEcosystemPage />
    </LandingLayout>
  );
}
